<div class="row">
  <!-- Botones de Admin -->
  @if (statistics.userRole == UserRole.Admin) {

    @if (canShowCreateDoctor()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateDoctor()"
              class="card-icon shadow-primary bg-orange pointer"
              data-tour="dashboard-create-doctor"
            >
              <i class="material-icons align-middle">person_add</i>
            </div>
            <span style="color: orange;">
              <br>CREAR <br>
              <span style="color: orange; font-size: 22px">NUEVO MEDICO</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreateUser()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateUser()"
              class="card-icon shadow-primary bg-cyan pointer"
              data-tour="dashboard-create-personal"
            >
              <i class="material-icons align-middle">person_add</i>
            </div>
            <span style="color: deepskyblue;">
              <br>CREAR <br>
              <span style="color: deepskyblue; font-size: 22px">NUEVO PERSONAL</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreateBranch()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateBranch()"
              class="card-icon shadow-primary bg-green pointer"
              data-tour="dashboard-create-branch"
            >
              <i class="material-icons align-middle">business</i>
            </div>
            <span style="color: green;">
              <br>CREAR <br>
              <span style="color: green; font-size: 22px">NUEVA SUCURSAL</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreateSupply()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateSupply()"
              class="card-icon shadow-primary bg-purple pointer"
            >
              <i class="fas fa-pills"></i>
            </div>
            <span style="color: rebeccapurple;">
              <br>SURTIR <br>
              <span style="color: rebeccapurple; font-size: 22px">NUEVA RECETA</span>
            </span>
          </div>
        </div>
      </div>
    }
  }

  <!-- Botones de Supervisor de Sucursales -->
  @if (statistics.userRole == UserRole.Supervisor_Sucursales) {

    @if (canShowCreateBranch()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateBranch()"
              class="card-icon shadow-primary bg-green pointer"
              data-tour="dashboard-create-branch"
            >
              <i class="material-icons align-middle">business</i>
            </div>
            <span style="color: green;">
              <br>CREAR <br>
              <span style="color: green; font-size: 22px">NUEVA SUCURSAL</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreateUser()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateUser()"
              class="card-icon shadow-primary bg-cyan pointer"
              data-tour="dashboard-create-personal"
            >
              <i class="material-icons align-middle">person_add</i>
            </div>
            <span style="color: deepskyblue;">
              <br>CREAR <br>
              <span style="color: deepskyblue; font-size: 22px">NUEVO PERSONAL</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreateDoctor()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateDoctor()"
              class="card-icon shadow-primary bg-orange pointer"
              data-tour="dashboard-create-doctor"
            >
              <i class="material-icons align-middle">person_add</i>
            </div>
            <span style="color: orange;">
              <br>CREAR <br>
              <span style="color: orange; font-size: 22px">NUEVO MEDICO</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreateSupply()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateSupply()"
              class="card-icon shadow-primary bg-purple pointer"
            >
              <i class="fas fa-pills"></i>
            </div>
            <span style="color: rebeccapurple;">
              <br>SURTIR <br>
              <span style="color: rebeccapurple; font-size: 22px">NUEVA RECETA</span>
            </span>
          </div>
        </div>
      </div>
    }
  }

  <!-- Botones de Responsable de Farmacia -->
  @if (statistics.userRole == UserRole.Responsable_Farmacia) {

    @if (canShowCreateUser()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateUser()"
              class="card-icon shadow-primary bg-cyan pointer"
            >
              <i class="material-icons align-middle">person_add</i>
            </div>
            <span style="color: deepskyblue;">
              <br>CREAR <br>
              <span style="color: deepskyblue; font-size: 22px">NUEVO EMPLEADO</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreateDoctor()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateDoctor()"
              class="card-icon shadow-primary bg-orange pointer"
              data-tour="dashboard-create-doctor"
            >
              <i class="material-icons align-middle">person_add</i>
            </div>
            <span style="color: orange;">
              <br>CREAR <br>
              <span style="color: orange; font-size: 22px">NUEVO MEDICO</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreateSupply()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreateSupply()"
              class="card-icon shadow-primary bg-purple pointer"
            >
              <i class="fas fa-pills"></i>
            </div>
            <span style="color: rebeccapurple;">
              <br>SURTIR <br>
              <span style="color: rebeccapurple; font-size: 22px">NUEVA RECETA</span>
            </span>
          </div>
        </div>
      </div>
    }
  }

  <!-- Botones de Medico -->
  @if (statistics.userRole == UserRole.Medico || statistics.userRole == UserRole.Particular) {

    @if (canShowCreatePatient()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreatePatient()"
              class="card-icon shadow-primary bg-cyan pointer"
              data-tour="dashboard-create-patient"
            >
              <i class="material-icons align-middle">person_add</i>
            </div>
            <span style="color: deepskyblue;">
              <br>CREAR <br>
              <span style="color: deepskyblue; font-size: 22px">NUEVO PACIENTE</span>
            </span>
          </div>
        </div>
      </div>
    }

    @if (canShowCreatePrescription()) {
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card card-statistic-2">
          <div class="clearfix">
            <div
              (click)="onCreatePrescription()"
              class="card-icon shadow-primary bg-blue pointer"
            >
              <i class="fas fa-file-prescription"></i>
            </div>
            <span style="color: #1f91f3;">
              <br>CREAR <br>
              <span style="color: #1f91f3; font-size: 22px">NUEVA RECETA</span>
            </span>
          </div>
        </div>
      </div>
    }
  }

  <!-- Botones de Paciente -->
  @if (canShowCreateHealthEvent()) {
    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <div class="card card-statistic-2" (click)="onNuevoEventoClick()">
        <div class="clearfix">
          <div class="card-icon shadow-primary bg-blue pointer">
            <i class="fas fa-file"></i>
          </div>
          <span style="color: #1f91f3;">
            <br>CREAR <br>
            <span style="color: #1f91f3; font-size: 22px">NUEVO EVENTO</span>
          </span>
        </div>
      </div>
    </div>
  }
</div>
